import React from "react";
import {connect} from "react-redux";

function Supporting(props) {
    if (props.donePageLoading !== true) {
        return <p/>
    }
    // TOP page only. not search and purchased
    if (props.sortType !== "date" && props.sortType !== "search"){
        return <p/>
    }

    return (
        <>
			{props.language === 'ja_JP' ? (
                <section className="home-credit">
                    <section className="home-credit-block">
                      <div className="home-credit-block__inner">
                        <h2 className="home-credit-block__title">主催</h2>
                        <p>
                            東京・春・音楽祭実行委員会
                        </p>
                      </div>
                    </section>
                    <section className="home-credit-block companies">
                        <div className="companies__inner home-credit-block__inner">
                            <h2 className="companies__title">協賛</h2>
                            <div className="support-list-wrapper">

                        <ul className="support-list platinum">
                            <li>
                                <a href="https://www.iij.ad.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_iij.png" alt="株式会社インターネットイニシアティブ" /></a>
                            </li>
                            <li>
                                <a href="https://www.smfg.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_smbc.png" alt="株式会社三井住友フィナンシャルグループ" /></a>
                            </li>
                            <li>
                                <a href="https://www.mitsuifudosan.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_mitsuifudosan.png" alt="三井不動産株式会社" /></a>
                            </li>
                        </ul>

                        <ul className="support-list gold">
                            <li>
                                <a href="https://www.iijglobal.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_iijglobal.png" alt="株式会社IIJグローバルソリューションズ" /></a>
                            </li>
                            <li>
                                <a href="https://www.itochu.co.jp/ja/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_itochu.png" alt="伊藤忠商事株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.ctc-g.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_ctc.png" alt="伊藤忠テクノソリューションズ株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://group.ntt/jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_nttgroupe.png" alt="日本電信電話株式会社" /></a>
                            </li>
                            <li>
                                <a href="http://www.okamura.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_okamura.png" alt="株式会社オカムラ" /></a>
                            </li>
                            <li>
                                <a href="https://www.kddi.com" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_kddi.png" alt="KDDI株式会社" /></a>
                            </li>
                            <li>
                            <a href="https://bridge-asia.org/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_compass.png" alt="株式会社コンパス" /></a>
                            </li>
                            <li>
                                <a href="https://www.shimz.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_shimizukensetsu.png" alt="清水建設株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.sumitomocorp.com/ja/jp" target="_blank"
                                    rel="noopener noreferrer"><img src="./assets/img/supporter_logo/supporter_logo_sumitomo.png"
                                        alt="住友商事株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.dai-ichi-life-hd.com/" target="_blank"
                                    rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_daiichiseimei.png" alt="第一生命保険株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.nissay.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_nihonseimei.png" alt="日本生命保険相互会社" /></a>
                            </li>
                            <li>
                                <a href="https://jprs.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_jprs.png"
                                        alt="株式会社日本レジストリサービス" /></a>
                            </li>
                            <li>
                                <a href="https://www.ms-ins.com" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_mitsuisumitomokaijyo.png"
                                        alt="三井住友海上火災保険株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.meijiyasuda.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_meijiyasudaseimei.png"
                                        alt="明治安田生命保険相互会社" /></a>
                            </li>
                        </ul>


                        <ul className="support-list silver">
                            <li>
                                <a href="https://www.iij-engineering.co.jp" target="_blank"
                                    rel="noopener noreferrer"><img src="./assets/img/supporter_logo/supporter_logo_iijeg.png"
                                        alt="株式会社IIJエンジニアリング" /></a>
                            </li>
                            <li>
                                <a href="https://www.ana.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_ana.png" alt="全日本空輸株式会社" /></a>
                            </li>

                            <li>
                                <a href="https://www.ntt.com/index.html" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_nttcommunications.png"
                                        alt="NTTコミュニケーションズ株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.ntt-east.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_ntthigashinihon.png"
                                        alt="東日本電信電話株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.sigmaxyz.com" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_sigmaxyz.png" alt="株式会社シグマクシス・ホールディングス" /></a>
                            </li>
                            <li>
                                <a href="http://www.sumitomo-rd.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_sumitomofudosan.png"
                                        alt="住友不動産株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.dell.com/ja-jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_dell.png" alt="デル・テクノロジーズ株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.toyotasystems.com" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_toyotasystems.png" alt="株式会社トヨタシステムズ" /></a>
                            </li>
                            <li>
                                <a href="https://www.ncj.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_nci.png" alt="ネットチャート株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.nomura.com/jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_nomura.png" alt="野村證券株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.hankyu.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_hankyu.png" alt="阪急電鉄株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://hirose-fx.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_hirose.png" alt="ヒロセ通商株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.fujitsu.com/jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_fujitsu.png" alt="富士通株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.furukawa.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_furukawadenko.png" alt="古河電気工業株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.bayview.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_bayview.png"
                                        alt="ベイビュー・アセット・マネジメント株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.uacj.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_uacj.png"
                                        alt="株式会社UACJ" /></a>
                            </li>
                        </ul>

                        <ul className="support-list bronze">
                            <li>
                                <a href="https://www.ayana.com/ja" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_ayana.png" alt="アヤナ ホテル" /></a>
                            </li>
                            <li>
                                <a href="https://www.exeo.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_exeo.png" alt="エクシオグループ株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.nttdata.com/jp/ja/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_nttdata.png" alt="株式会社NTTデータ" /></a>
                            </li>
                            <li>
                                <a href="https://www.nttdocomo.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_docomo.png" alt="株式会社NTTドコモ" /></a>
                            </li>
                            <li>
                                <a href="https://www.nttud.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_ntttoshikaihatsu.png"
                                        alt="NTT都市開発株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.bk.mufg.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_mitsubishiufjginko.png"
                                        alt="株式会社三菱UFJ銀行" /></a>
                            </li>
                            <li>
                                <a href="http://www.k-ohba.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_ohba.png"
                                        alt="株式會社オオバ" /></a>
                            </li>
                            <li>
                                <a href="https://www.kajima.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_kashima.png" alt="鹿島建設株式会社" /></a>
                            </li>
                            <li>
                                <a href="http://www.kel.co.jp/index.html" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_kel.png" alt="兼松エレクトロニクス株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.comture.com/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_comture.png"
                                        alt="コムチュア株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://xpoint.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_crosspoint.png"
                                        alt="株式会社クロスポイント・アドバイザーズ" /></a>
                            </li>
                            <li>
                                <a href="https://www.serverworks.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_serverworks.png"
                                        alt="株式会社サーバーワークス" /></a>
                            </li>
                            <li>
                                <a href="https://www.xymax.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_xymax.png" alt="株式会社ザイマックス" /></a>
                            </li>
                            <li>
                                <a href="https://jp.corp-sansan.com/" target="_blank"
                                    rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_sansan.png"
                                        alt="Sansan株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.suntory.co.jp/group/sbs/" target="_blank"
                                    rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_suntorybeveragesolution.png"
                                        alt="サントリービバレッジソリューション株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.jreast.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_jrhigashi.png" alt="東日本旅客鉄道株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.salesforce.com/jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_salesforce.png"
                                        alt="株式会社セールスフォース・ジャパン" /></a>
                            </li>
                            <li>
                                <a href="https://www.sojitz-ti.com/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_sojitz-tech-inovation.png" alt="双日テックイノベーション株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.scft.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_sociofuture.png" alt="SocioFuture株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.softbank.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_softbank.png" alt="ソフトバンク株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.daiwa.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_daiwasyoken.png" alt="大和証券株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.tis.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_tis.png" alt="TIS株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.tbs.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_tbs.png" alt="株式会社TBSテレビ" /></a>
                            </li>
                            <li>
                                <a href="https://www.tokyometro.jp/index.html" target="_blank"
                                    rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_tokyometro.png" alt="東京地下鉄株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.toyota-tsusho.com" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_toyotatsusyo.png" alt="豊田通商株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.trendmicro.com/ja_jp/business.html" target="_blank"
                                    rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_trendmicro.png" alt="トレンドマイクロ株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.post.japanpost.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_nipponyubin.png" alt="日本郵便株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://bydjapan.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_byd.png" alt="BYD Auto Japan株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.fujielectric.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_fujidenki.png" alt="富士電機株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.pagerduty.co.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_pagerduty.png" alt="PagerDuty株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.maeda.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_maedakensetsu.png" alt="前田建設工業株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.mfeed.ad.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_internetmfeed.png"
                                        alt="インターネットマルチフィード株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.mizuhobank.co.jp/retail/index.html" target="_blank"
                                    rel="noopener noreferrer"><img src="./assets/img/supporter_logo/supporter_logo_mizuho.png"
                                        alt="株式会社みずほ銀行" /></a>
                            </li>
                            <li>
                                <a href="https://www.smtb.jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_mitsuisumitomoshintakuginko.png"
                                        alt="三井住友信託銀行株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.mec.co.jp" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_mitsubishijisyo.png" alt="三菱地所株式会社" /></a>
                            </li>
                            <li>
                                <a href="https://www.uzabase.com/jp/" target="_blank" rel="noopener noreferrer"><img
                                        src="./assets/img/supporter_logo/supporter_logo_uzabase.png" alt="株式会社ユーザベース" /></a>
                            </li>
                            <li>
                                <img src="./assets/img/supporter_logo/supporter_logo_other.png"/>
                            </li>
                        </ul>

                            </div>
                        </div>
                    </section>

                    <section className="home-credit-block">
                      <div className="home-credit-block__inner">
                        <h2 className="home-credit-block__title">助成</h2>
                        <p>
                            公益社団法人企業メセナ協議会　社会創造アーツファンド
                        </p>
                      </div>
                    </section>
                </section>
			) : (
                <section className="home-credit">
                    <section className="home-credit-block">
                      <div className="home-credit-block__inner">
                        <h2 className="home-credit-block__title">Organizer</h2>
                        <p>
                            Spring Festival in Tokyo Executive Committee
                        </p>
                      </div>
                    </section>
                    <section className="companies home-credit-block">
                        <div className="companies__inner home-credit-block__inner">
                            <h2 className="companies__title">Sponsor</h2>
                            <div className="support-textlist-wrapper">
                                <ul className="support-textlist-wrapper__list">
                                    <li className="support-textlist-wrapper__item">Internet Initiative Japan Inc.</li>
                                    <li className="support-textlist-wrapper__item">Mitsui Fudosan Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">Sumitomo Mitsui Financial Group, Inc.</li>
                                    <li className="support-textlist-wrapper__item">Compass Company Ltd.</li>
                                    <li className="support-textlist-wrapper__item">Dai-ichi Life Holdings, Inc.</li>
                                    <li className="support-textlist-wrapper__item">IIJ Global Solutions Inc.</li>
                                    <li className="support-textlist-wrapper__item">ITOCHU Corporation</li>
                                    <li className="support-textlist-wrapper__item">ITOCHU Techno-Solutions Corporation</li>
                                    <li className="support-textlist-wrapper__item">Japan Registry Services Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">KDDI CORPORATION</li>
                                    <li className="support-textlist-wrapper__item">Meiji Yasuda Life Insurance Company</li>
                                    <li className="support-textlist-wrapper__item">Mitsui Sumitomo Insurance Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">NTT, Inc.</li>
                                    <li className="support-textlist-wrapper__item">Nippon Life Insurance Company</li>
                                    <li className="support-textlist-wrapper__item">OKAMURA CORPORATION</li>
                                    <li className="support-textlist-wrapper__item">SHIMIZU CORPORATION</li>
                                    <li className="support-textlist-wrapper__item">Sumitomo Corporation</li>
                                    <li className="support-textlist-wrapper__item">ALL NIPPON AIRWAYS CO., LTD.</li>
                                    <li className="support-textlist-wrapper__item">Bayview Asset Management Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">Dell Technologies Japan Inc.</li>
                                    <li className="support-textlist-wrapper__item">FUJITSU LIMITED</li>
                                    <li className="support-textlist-wrapper__item">Furukawa Electric Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">Hankyu Corporation</li>
                                    <li className="support-textlist-wrapper__item">Hirose Tusyo Inc.</li>
                                    <li className="support-textlist-wrapper__item">IIJ Engineering Inc.</li>
                                    <li className="support-textlist-wrapper__item">Net Chart Japan Inc.</li>
                                    <li className="support-textlist-wrapper__item">NTT DOCOMO BUSINESS, Inc</li>
                                    <li className="support-textlist-wrapper__item">NTT EAST, Inc.</li>
                                    <li className="support-textlist-wrapper__item">Nomura Securities Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">SIGMAXYZ Holdings Inc.</li>
                                    <li className="support-textlist-wrapper__item">Sumitomo Realty & Development Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">TOYOTA SYSTEMS CORPORATION</li>
                                    <li className="support-textlist-wrapper__item">UACJ Corporation</li>
                                    <li className="support-textlist-wrapper__item" style={{fontSize:"10px"}}>（UACJ Karoyaka Foundation）</li>
                                    <li className="support-textlist-wrapper__item">AYANA HOTEL</li>
                                    <li className="support-textlist-wrapper__item">BYD Auto Japan Inc.</li>
                                    <li className="support-textlist-wrapper__item">COMTURE CORPORATION</li>
                                    <li className="support-textlist-wrapper__item">Crosspoint Advisors, Inc.</li>
                                    <li className="support-textlist-wrapper__item">Daiwa Securities Co.,Ltd.</li>
                                    <li className="support-textlist-wrapper__item">East Japan Railway Company</li>
                                    <li className="support-textlist-wrapper__item">EXEO Group, Inc.</li>
                                    <li className="support-textlist-wrapper__item">Fuji Electric Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">INTERNET MULTIFEED CO.</li>
                                    <li className="support-textlist-wrapper__item">JAPAN POST Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">KAJIMA CORPORATION</li>
                                    <li className="support-textlist-wrapper__item">KANEMATSU ELECTRONICS LTD.</li>
                                    <li className="support-textlist-wrapper__item">MAEDA CORPORATION</li>
                                    <li className="support-textlist-wrapper__item">MITSUBISHI ESTATE CO., LTD.</li>
                                    <li className="support-textlist-wrapper__item">Mizuho Bank, Ltd.</li>
                                    <li className="support-textlist-wrapper__item">MUFG Bank, Ltd.</li>
                                    <li className="support-textlist-wrapper__item">NTT DATA Japan Corporation</li>
                                    <li className="support-textlist-wrapper__item">NTT DOCOMO, INC.</li>
                                    <li className="support-textlist-wrapper__item">NTT Urban Development Corporation</li>
                                    <li className="support-textlist-wrapper__item">OHBA CO.,LTD.</li>
                                    <li className="support-textlist-wrapper__item">PagerDuty, Inc</li>
                                    <li className="support-textlist-wrapper__item">Salesforce Japan Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">Sansan, Inc.</li>
                                    <li className="support-textlist-wrapper__item">Serverworks Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">SocioFuture, Ltd.</li>
                                    <li className="support-textlist-wrapper__item">SoftBank Corp.</li>
                                    <li className="support-textlist-wrapper__item">Sojitz Tech-Inovation Co.,Ltd.</li>
                                    <li className="support-textlist-wrapper__item">Sumitomo Mitsui Trust Bank, Limited</li>
                                    <li className="support-textlist-wrapper__item">SUNTORY BEVERAGE SOLUTION LIMITED</li>
                                    <li className="support-textlist-wrapper__item">TIS Inc.</li>
                                    <li className="support-textlist-wrapper__item">TOKYO BROADCASTING SYSTEM TELEVISION, INC.</li>
                                    <li className="support-textlist-wrapper__item">Tokyo Metro Co., Ltd.</li>
                                    <li className="support-textlist-wrapper__item">Toyota Tsusho Corporation.</li>
                                    <li className="support-textlist-wrapper__item">Trend Micro Incorporated</li>
                                    <li className="support-textlist-wrapper__item">Uzabase, Inc.</li>
                                    <li className="support-textlist-wrapper__item">XYMAX Corporation</li>
                                    <li className="support-textlist-wrapper__item">／etc</li>
                                </ul>
                            </div>
                        </div>
                    </section>

                    <section className="home-credit-block">
                      <div className="home-credit-block__inner">
                        <h2 className="home-credit-block__title">Granted</h2>
                        <p>
                            Association for Corporate Support of the Arts, Japan：Arts Fund for Creation of Society
                        </p>
                      </div>
                    </section>
                </section>
            )}
        </>
    )
}



const mapStateToProps = (state) => {
    return {
        language: state.piano.language,
        donePageLoading: state.offer.donePageLoading
    }
}

export default connect(mapStateToProps)(Supporting)